import React, {useEffect} from 'react'
import integrationsBG from '../../images/integrationsBG.webp'
import jumpSeller from '../../images/jumpseller_logo.webp'
import bsaleLogo from '../../images/bsale_logo.webp'
import woocommerceLogo from '../../images/woocommerce_logo.webp'
import api_rest from '../../images/api_rest.webp'
import mercadoLibre from '../../images/aliado1.webp'
import webohooks from '../../images/webohooks.webp'
import shopify from '../../images/shopify_logo.webp'
import prestashop from '../../images/prestashop-logo.webp'
import magneto from '../../images/magneto-logo.webp'
// import enviame from '../../images/aliado2.webp'
// import shippit from '../../images/aliado3.webp'
// import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Integrations() {

    useEffect(() => {
        // Inicializa AOS solo cuando el componente se monta en el cliente
        AOS.init({
          duration: 500,
          easing: 'ease-in-out',
        });
      }, []);

    const settings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 6,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
              }
            },
        ]
    };

  return (
    <div className="Content__integrations">
        <div className="container">
            <div className="Content__integrations--container">
                <div className="Content__integrations--banner">
                    <img src={integrationsBG} alt="integraciones-imagen-de-fondo" width="599" height="557" />
                </div>
                <div className="Content__integrations--details" data-aos="fade-up" data-aos-delay="300">
                    <div className="Content__integrations--title">
                        <h2>Integraciones <span>que trabajamos</span></h2>
                    </div>
                    <div className="Content__integrations--subtitle">
                        <span>en nuestro dashboard</span>
                    </div>
                    <div className="Content__integrations--description">
                        <p>Nuestro servicio está completamente habilitado para integrarse mediante webhooks y API REST, lo que permite una sincronización fluida y en tiempo real con tus sistemas.</p>
                        <p>Además, estamos orgullosos de anunciar nuestra integración directa con <strong>MercadoLibre</strong>, una de las plataformas de comercio electrónico más grandes y populares de Latinoamérica.</p>
                        <p>La configuración es sencilla, y nuestro equipo de soporte está siempre disponible para ayudarte a integrar tu cuenta de <strong>MercadoLibre</strong> con nuestra plataforma, asegurando que puedas empezar a mejorar tus procesos de entrega desde el primer momento.</p>
                    </div>
                    <Slider {...settings} className="Content__integrations--list">
                        <div className="Content__integrations--list-item">
                            <img src={mercadoLibre} alt="mercado-libre-logo" width="168" height="50" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={jumpSeller} alt="jumpseller-logo" width="168" height="46" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={bsaleLogo} alt="bsale-logo" width="145" height="59" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={woocommerceLogo} alt="woocommerce-logo" width="168" height="34" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={api_rest} alt="api-rest-logo" width="168" height="105" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={webohooks} alt="webhooks-logo" width="168" height="46" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={shopify} alt="shopify-logo" width="168" height="47" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={prestashop} alt="prestashop-logo" width="168" height="94" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={magneto} alt="magento-logo" width="168" height="49" />
                        </div>
                        {/* <div className="Content__integrations--list-item">
                            <img src={shippit} alt="shipit-logo" width="168" />
                        </div>
                        <div className="Content__integrations--list-item">
                            <img src={enviame} alt="enviame-logo" width="168" />
                        </div> */}
                    </Slider>
                    {/* <div className="Content__integrations--button">
                        <Link to={'/servicios'}>
                            <button>Nuestros Servicios</button>
                        </Link>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export { Integrations }